// @noflow
import { getDayScheduleEvents, getSelectedDay, getSelectedEvent } from '~/core/state/ui/schedule/selectors';

import { connect } from 'react-redux';
import { flowRight } from 'lodash/fp';
import { hidePopup } from '~/core/state/ui/schedule/actions';
import Popup from './component';

const MINUTES_IN_DAY = 1440;

const mapStateToProps = (state, { componentId }) => {
    const selectedDay = getSelectedDay(state, { componentId });
    const selectedEvent = getSelectedEvent(state, { componentId });
    const dayEvents = getDayScheduleEvents(state, {
        componentId,
        dayIndex: selectedDay
    });

    if (!selectedDay || !selectedEvent || !dayEvents) {
        return;
    }

    const isPreviousDayEvent = selectedEvent.get('dayIndex') !== selectedDay;
    const nextEvent = dayEvents.get(isPreviousDayEvent ? 1 : selectedEvent.get('eventIndex') + 2);
    const numEventsInSelectedDay = dayEvents.size;
    const selectedEventDuration =
        (nextEvent ? nextEvent.get('start') : MINUTES_IN_DAY) - (isPreviousDayEvent ? 0 : selectedEvent.get('start'));

    return {
        isPreviousDayEvent,
        numEventsInSelectedDay,
        selectedDay,
        selectedEvent,
        selectedEventDuration
    };
};

const mapDispatchToProps = (dispatch, { componentId }) => ({
    hidePopup: flowRight(dispatch, () => hidePopup({ componentId }))
});

export default connect(mapStateToProps, mapDispatchToProps)(Popup);



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/popup/index.js